import { navStore } from "../camera/nav.js";
import { invokeWorldTool } from "../data.js";
import { worldStore } from "../store.js";
import { BlueprintController } from "./controller.js";

/**
 * The blueprint controller of the Dünya page: reads the live scene and the user's capabilities,
 * calls `world.moveBuilding` / `history.undo` through the gateway and reports problems as toasts.
 */
export const blueprint = new BlueprintController({
  nodes: () => worldStore.nodes,
  caps: () => navStore.getState().caps,
  invoke: async (name, input) => {
    const result = await invokeWorldTool(name, input, worldStore.getFocus());
    return { output: result.output, correlationId: result.correlationId ?? null };
  },
  toast: (spec) => navStore.toast(spec),
});
